<app-modal-container
    #modalContainer
    (onClose)="close()"
    (onSave)="save()"
    [width]="550"
>
<!--  <div class="modal-header">-->
<!--    -->

<!--  </div>-->
  <div class="modal-body">
    <div class="title-holder">
      <span class="icon">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.5442 10.4154L9.85476 21.1049H0.771472V12.0216L11.4609 1.33211L20.5442 10.4154Z" fill="url(#paint0_linear_31033_29259)" stroke="url(#paint1_linear_31033_29259)"/>
          <defs>
          <linearGradient id="paint0_linear_31033_29259" x1="16.3562" y1="5.52024" x2="-0.0801888" y2="-4.61088" gradientUnits="userSpaceOnUse">
          <stop/>
          <stop offset="1" stop-color="white"/>
          </linearGradient>
          <linearGradient id="paint1_linear_31033_29259" x1="20.8329" y1="7.52248" x2="9.6957" y2="4.41288" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" stop-opacity="0"/>
          <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
          <stop offset="1" stop-color="white" stop-opacity="0"/>
          </linearGradient>
          </defs>
        </svg>
      </span>
      <h2>Відхилити персональну пропозицію</h2>
    </div>

    <div class="flex justify-content-center">
      <button class="btn btn-grey" (click)="cancel()">
        Відмінити
      </button>
      <button class="btn btn-black" (click)="save()">Підтвердити</button>
    </div>

  </div>

  <app-loading-animation *ngIf="isLoading"></app-loading-animation>
</app-modal-container>